// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__340xY","empty":"ModalGraph_empty__-J5ts"};